import React, { useState } from "react";
import { X, KeySquare, Loader2 } from "lucide-react";
import { getAuth, updatePassword } from "firebase/auth";
import { updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../../config/firebase";
import { appId } from "../../config/constants";

const ChangePasswordModal = ({ userData, onClose }) => {
    const [p1, setP1] = useState("");
    const [p2, setP2] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!p1 || !p2) { alert("請輸入"); return; }
        if (p1 !== p2) { alert("兩次輸入不一致"); return; }
        if (p1.length < 6) { alert("長度需至少 6 位"); return; }
        
        setLoading(true);
        try {
            const authInstance = getAuth();
            const u = authInstance.currentUser;
            if (!u) { alert("請重新登入後再試"); return; }

            await updatePassword(u, p1);
            const emailKey = (userData?.email || u.email || "").toLowerCase();
            if (emailKey) {
                await updateDoc(
                    doc(db, "artifacts", appId, "public", "data", "registered_users", emailKey),
                    { passwordUpdatedAt: serverTimestamp() }
                );
            }
            alert("✅ 密碼修改成功！");
            onClose();
        } catch (e) {
            alert("修改失敗：" + (e?.message || String(e)));
        } finally {
            setLoading(false);
        }
    };

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
        <div className="bg-white rounded-[2rem] w-full max-w-sm overflow-hidden shadow-2xl relative" onClick={e => e.stopPropagation()}>
          <div className="bg-slate-900 p-6 text-white relative">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
              <h3 className="text-xl font-black tracking-wide flex items-center gap-2"><KeySquare size={24} className="text-orange-400"/> 修改密碼</h3>
          </div>
          <div className="p-6 space-y-4">
              <div>
                  <input type="password" value={p1} onChange={e => setP1(e.target.value)} placeholder="輸入新密碼 (至少 6 位)" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold outline-none focus:border-orange-400 transition-all"/>
              </div>
              <div>
                  <input type="password" value={p2} onChange={e => setP2(e.target.value)} placeholder="再次確認密碼" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold outline-none focus:border-orange-400 transition-all"/>
              </div>
              <button onClick={handleSubmit} disabled={loading} className="w-full py-3 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition-all active:scale-95">
                  {loading ? <Loader2 className="animate-spin mx-auto"/> : "確認修改"}
              </button>
          </div>
        </div>
      </div>
    );
};

export default ChangePasswordModal;
